import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { queryClient } from 'lib/queryClient';
import {
  clearChunkReloadAttempt,
  isChunkLoadError,
  tryReloadOnceForChunkLoadError,
} from 'utils/chunkLoadError';
import { registerAbrafiServiceWorker } from 'utils/registerAbrafiServiceWorker';
import { reactRouterBasenameFromBaseUrl } from 'utils/vitePublicUrlBase';
import { startWebAppInstallPromptCapture } from 'utils/webAppInstallPrompt';
import './i18n';
import './index.css';
import { ThemeProvider } from 'contexts/ThemeContext';
import { initThemeFromStorage } from 'theme/themePreference';
import App from './App';
import reportWebVitals from './reportWebVitals';

clearChunkReloadAttempt();
initThemeFromStorage();
startWebAppInstallPromptCapture();
registerAbrafiServiceWorker();

const basename = reactRouterBasenameFromBaseUrl(import.meta.env.BASE_URL);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter basename={basename}>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

window.addEventListener('unhandledrejection', (event) => {
  if (isChunkLoadError(event.reason)) {
    if (tryReloadOnceForChunkLoadError(event.reason)) {
      event.preventDefault();
      return;
    }
  }
  console.error('Unhandled promise rejection:', event.reason);
});

window.addEventListener('error', (event) => {
  if (isChunkLoadError(event.error)) {
    if (tryReloadOnceForChunkLoadError(event.error)) {
      event.preventDefault();
      return;
    }
  }
  console.error('Uncaught error:', event.error);
});

reportWebVitals();
